export default __webpack_public_path__ + "static/media/upcoming-banner-1.9d3bc79b.png";